<template>
  <div v-if="recom">
    <div class="media">
      <figure class="media-left">
        <p class="image logo">
          <img :src="getImg(pointDeVente.urlLogo)">
        </p>
      </figure>
      <div class="media-content">
        <h3 v-if="libelle" class="has-text-weight-bold is-size-18px has-text-grid-1">
          {{ libelle }}
        </h3>
        <p v-if="recom.dateCreation" class="is-size-7 has-text-default">
          {{ formatDate(recom.dateCreation) }}
        </p>
        <p class="is-size-7 has-text-default is-italic">
          Proposition sous réserve de disponibilité
        </p>
      </div>
      <div class="media-right"></div>
    </div>
    <div class="card mt-30" v-if="commentaire">
      <div class="card-content pa-20">
        <img class="positionLight" src="@/assets/images/img_ampoule.svg">
        <p class="title is-size-14px has-text-weight-bold has-text-grid-1 mb-0">
          Notre préconisation
        </p>
        <p class="subtitle is-size-14px has-text-default mt-10 mb-10">
          {{ commentaire }}
        </p>
      </div>
    </div>
    <div class="card mt-20">
      <div class="card-content pa-20 title is-size-14px has-text-weight-bold has-text-grid-1">
        <p class="mb-0">
          Le montant de la TLPE pourra varier lors de l’édition des contrats des régies
        </p>
        <p class="mt-10">
          Les dispositifs proposés sont sous réserve de disponibilité au moment de la validation
        </p>
        <p class="mt-10">
          Les fiches jaunes concernent des panneaux en cours de renouvellement
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { formatDate, getImg } from '@/services/general/general';

const Recommandation = createNamespacedHelpers('recommandation');

export default {
  computed: {
    ...Recommandation.mapGetters({
      recom: 'recom',
    }),
    pointDeVente() {
      return this.recom.pointDeVente;
    },
    commentaire() {
      return this.recom.commentaire;
    },
    libelle() {
      return [this.pointDeVente.libelle, this.recom.theme].filter(Boolean).join(' - ');
    },
  },
  methods: {
    getImg: getImg,
    formatDate: formatDate,
  },
  metaInfo() {
    return {
      title: this.pointDeVente.libelle,
      htmlAttrs: { lang: 'fr', amp: true }
    };
  },
}
</script>
